export default __webpack_public_path__ + "navigation-examples-route-init-thumbnail-960-03a4bf66ca4ad32354c7e32899cf60ad.webp";